<template>
  <div
    ref="recommendationCard"
    class="recommendation-card"
    v-if="recommendation"
  >
    <div
      class="image-slot"
      :style="{ 'background-image': `url(${recommendation.image})` }"
    ></div>
    <div class="recommendation-card-content">
      <h5 :title="recommendation.title" class="recommendation-card-title">
        {{ recommendation.title | truncateText(30) }}
      </h5>
      <small
        class="recommendation-card-metric"
        v-for="metric in recommendation.metrics"
        :key="metric.id"
      >
        <img class="recommendation-icon" :src="metric.image" />
        {{ metric.label }}
      </small>
      <b-button
        @click="loadModalContent(recommendation)"
        variant="outline-primary"
      >
        {{ labels.button }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    recommendation: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const { recommendationCard } = this.$refs
    this.$emit('loadCard', recommendationCard)
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.recommendationCard
    },
  },
  methods: {
    loadModalContent(recommendation) {
      this.$emit('recommendationButtonClicked', recommendation)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';

$cardWidth: 240px;
$cardBorderRadius: 8px;

.image-slot {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  height: 130px;
  border-radius: 8px 8px 0 0;
}

.recommendation-card {
  background: map-get($theme-colors, 'white');
  border: 1px solid map-get($theme-colors, 'gray01');
  border-radius: $cardBorderRadius;
  color: map-get($theme-colors, 'primary');
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  font-size: 16px;
  justify-content: space-between;
  margin: 0 5px;
  max-width: $cardWidth;
}

.recommendation-card-title {
  height: 50px;
}

.btn {
  // flex-grow: 1;
  font-size: 14px;
  margin-top: 10px;
}

.recommendation-icon {
  height: 15px;
  vertical-align: text-bottom;
}

.recommendation-card-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 10px 20px;
}
</style>
